import React from 'react';
import './Footer.css';
import cindetemm from '../../icons/cindetemm.png'; // Importa la imagen desde la carpeta icons
import LogistiKa from '../../icons/logistika.png'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="img-content">
            <img src={LogistiKa} alt="LogistiKa Logo" />
        </div>
        <div className="info-content1" >
          <div className="info-content" >
            <div className="h3-content">
              <h3>Contacto:</h3>
            </div>
            <div className="contact-info">
              <p>Email: Contacto@cindetemm.org.co</p>
              <p>Web: <a href="https://www.cindetemm.org.co" target="_blank" rel="noopener noreferrer">www.cindetemm.org.co</a></p>
              <p>Tel: +57 301 1630878</p>
              <p>Dirección: Calle 35 #16-33, Guadalupe, Dosquebradas, Risaralda, CO</p>
            </div>
          </div>
        </div>
        <div>
            <div className="logo-section">
              <div>
                <p>Creado </p>
                <p>por: </p>
              </div>
              <img src={cindetemm} alt="LogistiKa Logo" />
            </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
